import { SET_NOTIFICATIONS } from './types';

export const setNotifications = (notifications) => (dispatch) =>
  dispatch({
    type: SET_NOTIFICATIONS,
    message: 'Notification changed',
    payload: notifications,
  });
